import { StatusObj } from "../../../../../types/models/apps/Todo";

const statusList: StatusObj[] = [
  { id: 1001, name: "Pending", type: 1 },
  { id: 1002, name: "In Progress", type: 2 },
  { id: 1003, name: "Completed", type: 3 },
];
export default statusList;
